import { render, staticRenderFns } from "./origin-data.vue?vue&type=template&id=6ddfc5bb&scoped=true"
import script from "./origin-data.vue?vue&type=script&lang=js"
export * from "./origin-data.vue?vue&type=script&lang=js"
import style0 from "./origin-data.vue?vue&type=style&index=0&id=6ddfc5bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ddfc5bb",
  null
  
)

export default component.exports